export interface Pager {
  pagination: PageInfo;
}

export interface PageInfo {
  
  limit: number;
  page: number;
  total_pages: number;
  total_records: number;
}

